module.exports = __webpack_public_path__ + "assets/img/up_d1.174fb022.png";